import { render, staticRenderFns } from "./leftBar.vue?vue&type=template&id=6c127c94&scoped=true&"
import script from "./leftBar.vue?vue&type=script&lang=js&"
export * from "./leftBar.vue?vue&type=script&lang=js&"
import style0 from "./leftBar.vue?vue&type=style&index=0&id=6c127c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c127c94",
  null
  
)

export default component.exports